import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { faqData } from '../data/mock';

export const FAQPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-black to-slate-900"></div>

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-purple-500/10 border border-purple-500/30 rounded-full px-4 py-2 mb-6">
              <span className="text-purple-300 text-sm font-medium">PREGUNTAS FRECUENTES</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              ¿Tienes dudas?
              <br />
              <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                Estamos aquí para ayudarte
              </span>
            </h1>
            <p className="text-gray-400 text-lg">
              Encuentra respuestas a las preguntas más comunes sobre VERSO
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="bg-white/5 backdrop-blur-sm border border-purple-500/20 rounded-xl px-6 hover:border-purple-500/40 transition-all duration-300"
              >
                <AccordionTrigger className="text-white hover:text-purple-400 text-left text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-16 text-center">
            <p className="text-gray-400 mb-4">
              ¿No encontraste lo que buscabas?
            </p>
            <button className="text-purple-400 hover:text-purple-300 font-semibold transition-colors">
              Contacta con nuestro equipo de soporte →
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};